<div class="pdfContain">
  <kendo-pdf-export #pdf>
    <div class="pdf">
      <div class="pdf-heading col-12 d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <div>
            <img class="app-logo" [src]="logoSrc" alt="App logo">
          </div>
          <div>
            <h5 class="ml-2">{{ translationKeys.SOPObservation.ObservationProtocol | translate }}</h5>
          </div>
        </div>
        <div class="px-5">
          <span class="observation-info">{{ formdata.ward.wardName | translate | labelSanitizer }}</span>
          <span class="specs-center observation-info">{{ formdata.department.departmentName | translate |
            labelSanitizer }}</span>
          <span class="observation-info">{{ formdata.category.categoryName | translate | labelSanitizer }}</span>
          <span class="specs-sub observation-info" *ngIf="showProfessionalSubcategory">{{
            formdata.subCategory.subCategoryName | translate | labelSanitizer }}</span>
          <div *ngIf="swappedSteps" class="swapped-box mt-1"><p class="m-0 swapped-text">{{ 'SOP_OBSERVATION.SWAPPED_STEPS' | translate }}</p></div>

        </div>
      </div>
      <div class="white-bg" style="height: 10px;"></div>
      <div class="white-bg">
        <h5 class="observation-title">{{ 'EVALUATION.SOP' | translate }}:
          {{sopName | translate | labelSanitizer}}</h5>
        <p class="m-0 observation-date">{{ 'EVALUATION.OBSERVATION_DATE' | translate }}: {{formdata.creationDate |
          date:'dd.MM.yyyy'}}
        </p>
      </div>
      <div class="image-container-fixedsize justify-content-md-start justify-content-center white-bg">
        <div class="d-flex justify-content-center image-div-scroll">
          <div class="row m-0 col-12 card-holder" #cardHolder>
            <ng-container *ngFor="let step of sopStep; let i = index">
              <div class="card card-strip" #card *ngIf="step.stepType" [class.mutli-step-start-image]='step.stepType'>
                <div *ngIf="i == 0" class="start-image d-flex align-items-center"></div>
                <div *ngIf="i == sopStepLength" class="start-image-end d-flex align-items-center">
                </div>
                <div class="card-task">
                  <div class="card-task-media" [style.opacity]="!showStepList[i] ? '0.5': '1'">
                    <img class="card-img-top multi-step-image-overlay"
                      [ngClass]="(step.stepImage)?'svg':'no-image'"
                      [src]="(step.stepImage)?layoutService.serverUrl+step.stepImage:'assets/img/fallback-img.png'"
                      (error)="errImg($event)" alt="SOP">
                    <span class="multiImage"></span>
                  </div>
                  <div class="card-task-content d-flex align-items-center"
                    [class.handDisinfy]="step.stepCards[0].hygieneRelevantStep">
                    <p class="card-task-desc card-text">
                      {{step.stepName | translate | labelSanitizer}}</p>
                  </div>
                </div>
              </div>
              <ng-template [ngIf]="!step.stepType || showStepList[i]">
                <div class="card card-strip" #card *ngFor="let stepCards of step.stepCards; let j = index"
                  [class.mutli-step-sub-cards]='step.stepType'>
                  <div *ngIf="i == 0 && !step.stepType" class="start-image d-flex align-items-center">
                  </div>
                  <div *ngIf="i == sopStepLength && !step.stepType" class="start-image-end d-flex align-items-center">
                  </div>
                  <div class="card-task"
                    [style.outline]="seletedSteps[i] && seletedSteps[i][j] ? '1px solid #0045ff' : ''">
                    <div class="d-flex justify-content-center icon-middle"
                      *ngIf="stepCards.hygieneRelevantStep && ( !seletedSteps[i] || ( seletedSteps[i] && !seletedSteps[i][j])) ">
                      <img src="assets/ph-bhp-sopobservation/SOP-Images/icon-thumb-down.svg" class="thumb-icon" />
                    </div>
                    <div class="d-flex justify-content-center icon-middle"
                      *ngIf="stepCards.hygieneRelevantStep &&  ( ( seletedSteps[i] && seletedSteps[i][j]))">
                      <img src="assets/ph-bhp-sopobservation/SOP-Images/icon-thumb-up.svg" class="thumb-icon" />
                    </div>
                  <div class="card-task-media" [style.opacity]="(
                    (!seletedSteps[i] || !seletedSteps[i][j]) ||
                    (
                      (stepCards.hygieneRelevantStep && ( !seletedSteps[i] || ( seletedSteps[i] && !seletedSteps[i][j]))) ||
                      (stepCards.hygieneRelevantStep &&  ( ( seletedSteps[i] && seletedSteps[i][j])))
                    )
                  ) ? '0.5': '1'">
                      <img class="card-img-top" [ngClass]="(stepCards.stepImage)?'svg':'no-image'"
                        [src]="(stepCards.stepImage)?layoutService.serverUrl+stepCards.stepImage:'assets/img/fallback-img.png'"
                        (error)="errImg($event)" alt="SOP">
                    </div>
                    <div class="card-task-content d-flex justify-content-between step-card align-items-start"
                      [class.handDisinfy]="stepCards.hygieneRelevantStep">
                      <p class="card-task-desc card-text">
                        {{stepCards.stepTittle | translate | labelSanitizer}}</p>
                      <div class="icons-div">
                        
                        <span *ngIf="seletedSteps[i] && seletedSteps[i][j]"
                          [ngClass]="seletedSteps[i][j].swapped ? 'stepbg-swapped' : 'stepbg'">
                          {{ seletedSteps[i][j]?.stepOrder }}</span>

                        <span class="noSterlity"
                          *ngIf="seletedSteps[i] && seletedSteps[i][j] && seletedSteps[i][j].noSterility"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="white-bg" *ngIf="comments.length > 0">
        <div class="comment-card col-lg-4">
          <div class="observation-comment-container">
            <h5 class="observation-title">{{ translationKeys.SOPObservation.Comments | translate }}</h5>
            <div *ngFor="let comment of comments;let i = index">
              <div class="comment-text-container row m-0 col-12 p-0 d-flex mb-2 justify-content-between">
                <div class="col-12 comment-card-protocol">
                  <p class="comment-step m-0">{{(comment.stepNumber) ? ('SOP_MANAGEMENT.STEP' | translate ) + ' ' +
                    comment.stepNumber + ' - ' + (comment.stepName | translate) : ('SOP_OBSERVATION.NO_STEP' |
                    translate)}}</p>
                  <p class="comment-text m-0">{{ comment.predefinedCommentText | translate }}</p>
                  <p class="comment-text m-0">{{ comment.freeTextComment | translate }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </kendo-pdf-export>
</div>
